import axios from "axios";
import Vue from "vue";
import modals from "../helpers/modals";

export default {
    bind($item, $bind, $vue) {
        let typing = 0;
        let counter = 0;
        let active = -1;
        let indexes = [];
        let anchors = [];
        $item.addEventListener('keyup', (event) => {
            event.stopPropagation();
            if (typing) {
                clearTimeout(typing);
            }

            switch ( event.key) {
                case 'Enter':
                    if ( 0 <= active && typeof anchors[active] !== "undefined") {
                        window.location = anchors[active];
                        event.preventDefault();
                        return false;
                    }
                    break;
                case 'Escape':
                    $vue.context.results[$item.dataset.bind] = {};
                    active = -1;
                    indexes = [];
                    break;
                case 'ArrowUp':
                    if (indexes.length) {
                        if ( active > 0 ) {
                            active --;
                            $vue.context.results[$item.dataset.bind].query = indexes[active];
                            $item.value = indexes[active];
                        }
                    }
                    break;
                case 'ArrowDown':
                    if (indexes.length) {
                        if ( active < counter - 1 ) {
                            active ++;
                            $vue.context.results[$item.dataset.bind].query = indexes[active];
                            $item.value = indexes[active];
                        }
                    }
                    break;
                default:
                    if (2 <= $item.value.length) {
                        typing = window.setTimeout(() => {
                            axios.get($item.dataset.source + '?q=' + $item.value ).then(data => {
                                counter = data.data.data.total;
                                indexes = [];
                                anchors = [];
                                active = -1;

                                ['actors', 'channels', 'categories', 'tags', 'partners', 'entities'].forEach((key) => {
                                    if ( typeof data.data.data[key] !== "undefined") {
                                        data.data.data[key].items.forEach((item) => {
                                            indexes.push(item.contents);
                                            anchors.push(item.link);
                                        });
                                    }
                                });

                                $vue.context.$nextTick(() => {
                                    $vue.context.results[$item.dataset.bind] = data.data.data;
                                });

                            });
                        }, 150);
                    } else {
                        $vue.context.$nextTick(() => {
                            $vue.context.results[$item.dataset.bind] = {};
                        });
                    }
                    break;
            }

        }, { passive: true });
    }
}
